import { render, staticRenderFns } from "./Npa.vue?vue&type=template&id=534ad4c8"
import script from "./Npa.vue?vue&type=script&lang=js"
export * from "./Npa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports